import type { CSSProperties } from 'react';
import { attachmentPreviewSize, MIN_ATTACHMENT_PREVIEW_SIZE, MAX_ATTACHMENT_PREVIEW_SIZE } from '../../shared/attachmentPreview';
import { t } from './i18n';

export function AttachmentPreviewSettings({ value, onChange }: { value: unknown; onChange: (size: number) => void }) {
  const size = attachmentPreviewSize(value);
  return (
    <fieldset className="attachment-preview-settings">
      <legend>{t('Attachment previews')}</legend>
      <label className="block" htmlFor="attachment-preview-size">
        {t('Maximum preview size')}: <output htmlFor="attachment-preview-size">{size} × {size} px</output>
      </label>
      <input id="attachment-preview-size" type="range" min={MIN_ATTACHMENT_PREVIEW_SIZE} max={MAX_ATTACHMENT_PREVIEW_SIZE} step={40}
        value={size} onChange={(e) => onChange(Number(e.target.value))} aria-valuetext={`${size} × ${size} px`} />
      <p className="muted small">{t('Images and video players fit within this size without cropping. Smaller screens limit the width automatically.')}</p>
      <div className="attachment-size-example" style={{ '--attachment-preview-size': `${size}px` } as CSSProperties}>
        <div className="small muted">{t('Example — changes immediately')}</div>
        <svg className="attachment-example-image" viewBox="0 0 720 405" role="img" aria-label={t('Example attachment preview')}>
          <rect width="720" height="405" rx="8" fill="var(--surface)" />
          <path d="M0 48H720M180 48V405" stroke="var(--border)" />
          <circle cx="24" cy="24" r="7" fill="var(--brand)" />
          <rect x="44" y="18" width="125" height="12" rx="4" fill="var(--border)" />
          {[80, 112, 144, 176, 208].map((y) => <rect key={y} x="20" y={y} width={y === 80 ? 132 : 100} height="12" rx="4" fill={y === 80 ? 'var(--brand-subtle)' : 'var(--border)'} />)}
          <text x="214" y="92" fontSize="21" fontFamily="system-ui" fill="var(--text)">{t('Performance overview')}</text>
          {[150, 210, 270, 330].map((y) => <path key={y} d={`M220 ${y}H680`} stroke="var(--border)" />)}
          <path d="M220 130V340H680" fill="none" stroke="var(--text-subtle)" />
          <path d="M240 155L310 225L380 260L450 285L520 300L590 308L660 312" fill="none" stroke="var(--brand)" strokeWidth="5" strokeLinejoin="round" />
          {[[240, 155], [310, 225], [380, 260], [450, 285], [520, 300], [590, 308], [660, 312]].map(([x, y]) => <circle key={x} cx={x} cy={y} r="5" fill="var(--brand)" />)}
        </svg>
      </div>
      <p className="muted small">{t('Save your preferences to use this size on issue attachments.')}</p>
    </fieldset>
  );
}
